// extracted by mini-css-extract-plugin
module.exports = {"twoColumns":"570px","threeColumns":"1440px"};